import { render, staticRenderFns } from "./MotorBikeLeftHandlebar.vue?vue&type=template&id=37d116b2"
import script from "./MotorBikeLeftHandlebar.vue?vue&type=script&lang=js"
export * from "./MotorBikeLeftHandlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports